module.exports = new __parcel__URL__("heart.3b5c2383.svg").toString();